import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { b_changeCurrentOrganization } from '../../../../../actions/bookingActions'
import {
    selectCurrentOrganization,
    selectOrganizationList
} from '../../../../../selectors/bookingSelectors/bookingCurrentOrganization'
import SelectWithSearch from '../OrganizationTab/SelectWithSearch'

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 200,
        color: 'white'
    }
})

class CurrentOrganization extends Component {
    handleChange = e => {
        if (this.props.value !== e.target.value) {
            this.props.onChangeOrganization(e.target.value)
        }
    }

    render() {
        const { organizationList, value, classes } = this.props

        const options = organizationList.map(org => ({
            value: org.ourId,
            label: org.ourName
        }))

        return (
            <form className={classes.root}>
                <FormControl className={classes.formControl}>
                    <SelectWithSearch
                        value={value}
                        label="Оберіть організацію"
                        onChange={this.handleChange}
                        options={options}
                    />
                </FormControl>
            </form>
        )
    }
}

CurrentOrganization.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    organizationList: PropTypes.array
}
CurrentOrganization.defaultProps = {
    value: ''
}

const mapStateToProps = state => ({
    value: selectCurrentOrganization(state),
    organizationList: selectOrganizationList(state)
})

const mapDispatchToProps = dispatch => ({
    onChangeOrganization: data => dispatch(b_changeCurrentOrganization(data))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CurrentOrganization))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/CurrentOrganization/CurrentOrganization.js